/*
 * Copyright (c) 2024 Bluemate B.V.
 */

import {ResponseData} from '@dvrd/dvr-controls';

import {getActiveUserEstimate} from './requestSender';

export const fallbackUsersEstimate = 1500;
let activeUsersEstimate: number | null = null;

export function getActiveUsersEstimate(): Promise<number> {
    return new Promise<number>(resolve => {
        if (activeUsersEstimate !== null) resolve(activeUsersEstimate);
        else {
            getActiveUserEstimate({
                callback: (data: ResponseData) => {
                    if (data.success) activeUsersEstimate = data.estimate;
                    resolve(activeUsersEstimate ?? fallbackUsersEstimate);
                }
            });
        }
    });
}
